export default __webpack_public_path__ + "static/media/5450.2f85edfe.png";